import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { TagsApiService } from '../apis/tags-api.service';
import { LocalStorageService } from '../lib/local-storage.service';
import { ModalDialogComponent } from '../modal-dialog/modal-dialog.component';
import { ReservationTagCategory } from '../model/reservation-tag';
import { TagType } from '../model/tag-type';
import { BatchCategoryUpdate, createTagCategoryUpdateDTO } from '../model/tags.dto';

@Component({
  selector: 'app-tag-category-modal',
  templateUrl: './tag-category-modal.component.html',
  styleUrls: ['./tag-category-modal.component.scss']
})
export class TagCategoryModalComponent implements OnInit {

  @Input() tagType: TagType = "RESERVATION";
  @Input() selectedCategory: ReservationTagCategory = new ReservationTagCategory();
  @ViewChild('modal') modal!: ModalDialogComponent;
  @Output() onClose: EventEmitter<ReservationTagCategory> = new EventEmitter();

  constructor(private tagsApi: TagsApiService, private localStorageService: LocalStorageService) { }

  ngOnInit(): void {
  }

  async categoryModalClosed(ok: boolean) {
    if (ok == false) {
      return;
    }

    await firstValueFrom(this.tagsApi.saveTags(
      createTagCategoryUpdateDTO(
        this.localStorageService.getRestaurantId() + "",
        this.selectedCategory,
        this.tagType)
    ));
  }
}
